// action
import {
    SAVE_SAMPLE,
    SAVE_SAMPLE_FAIL,
    SAVE_SAMPLE_SUCCESS,
    SAVE_SAMPLE_RESET
} from '../action/saveSampleAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_SAMPLE:
            return {
                ...state,
                apiState: "loading"
            }
        case SAVE_SAMPLE_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_SAMPLE_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case SAVE_SAMPLE_RESET:
            return initialState
        default:
            return state
    }
}